import {
  APPLICATION_FUNDING,
  APPLICATION_FUNDING_SUCCESS,
  APPLICATION_FUNDING_ERROR,
  UPDATE_APPLICATION_FUNDING,
  UPDATE_APPLICATION_FUNDING_SUCCESS,
  UPDATE_APPLICATION_FUNDING_ERROR,
  BANK_APPLICATION_FUNDING,
  BANK_APPLICATION_FUNDING_SUCCESS,
  BANK_APPLICATION_FUNDING_ERROR,
  UPDATE_BANK_APPLICATION_FUNDING,
  UPDATE_BANK_APPLICATION_FUNDING_SUCCESS,
  UPDATE_BANK_APPLICATION_FUNDING_ERROR,
  METAL_STREAM_FUNDING,
  METAL_STREAM_FUNDING_SUCCESS,
  METAL_STREAM_FUNDING_ERROR,
  UPDATE_METAL_STREAM_FUNDING,
  UPDATE_METAL_STREAM_FUNDING_SUCCESS,
  UPDATE_METAL_STREAM_FUNDING_ERROR,
  APPLICATION_FUNDING_AMOUNT,
  APPLICATION_FUNDING_AMOUNT_SUCCESS,
  APPLICATION_FUNDING_AMOUNT_ERROR,
  UPDATE_APPLICATION_FUNDING_AMOUNT,
  UPDATE_APPLICATION_FUNDING_AMOUNT_ERROR,
  UPDATE_APPLICATION_FUNDING_AMOUNT_SUCCESS,
  BANK_APPLICATION_FUNDING_AMOUNT,
  BANK_APPLICATION_FUNDING_AMOUNT_SUCCESS,
  BANK_APPLICATION_FUNDING_AMOUNT_ERROR,
  UPDATE_BANK_APPLICATION_FUNDING_AMOUNT,
  UPDATE_BANK_APPLICATION_FUNDING_AMOUNT_SUCCESS,
  UPDATE_BANK_APPLICATION_FUNDING_AMOUNT_ERROR,
  DELETE_APPLICATION_FUNDING,
  DELETE_APPLICATION_FUNDING_SUCCESS,
  DELETE_APPLICATION_FUNDING_ERROR,
} from './fundingActionConstants';

export const applicationFunding = (payload) => ({
  type: APPLICATION_FUNDING,
  payload,
});

export const applicationFundingSuccess = (payload) => ({
  type: APPLICATION_FUNDING_SUCCESS,
  payload,
});

export const applicationFundingError = (payload) => ({
  type: APPLICATION_FUNDING_ERROR,
  payload,
});

export const updateApplicationFunding = (payload) => ({
  type: UPDATE_APPLICATION_FUNDING,
  payload,
});

export const updateApplicationFundingSuccess = (payload) => ({
  type: UPDATE_APPLICATION_FUNDING_SUCCESS,
  payload,
});

export const updateApplicationFundingError = (payload) => ({
  type: UPDATE_APPLICATION_FUNDING_ERROR,
  payload,
});

export const deleteApplicationFunding = (payload) => ({
  type: DELETE_APPLICATION_FUNDING,
  payload,
});

export const deleteApplicationFundingSuccess = (payload) => ({
  type: DELETE_APPLICATION_FUNDING_SUCCESS,
  payload,
});

export const deleteApplicationFundingError = (payload) => ({
  type: DELETE_APPLICATION_FUNDING_ERROR,
  payload,
});

export const bankApplicationFunding = (payload) => ({
  type: BANK_APPLICATION_FUNDING,
  payload,
});

export const bankApplicationFundingSuccess = (payload) => ({
  type: BANK_APPLICATION_FUNDING_SUCCESS,
  payload,
});

export const bankApplicationFundingError = (payload) => ({
  type: BANK_APPLICATION_FUNDING_ERROR,
  payload,
});

export const updateBankApplicationFunding = (payload) => ({
  type: UPDATE_BANK_APPLICATION_FUNDING,
  payload,
});

export const updateBankApplicationFundingSuccess = (payload) => ({
  type: UPDATE_BANK_APPLICATION_FUNDING_SUCCESS,
  payload,
});

export const updateBankApplicationFundingError = (payload) => ({
  type: UPDATE_BANK_APPLICATION_FUNDING_ERROR,
  payload,
});

export const applicationFundingAmount = (payload) => ({
  type: APPLICATION_FUNDING_AMOUNT,
  payload,
});

export const applicationFundingAmountSuccess = (payload) => ({
  type: APPLICATION_FUNDING_AMOUNT_SUCCESS,
  payload,
});

export const applicationFundingAmountError = (payload) => ({
  type: APPLICATION_FUNDING_AMOUNT_ERROR,
  payload,
});

export const updateApplicationFundingAmount = (payload) => ({
  type: UPDATE_APPLICATION_FUNDING_AMOUNT,
  payload,
});

export const updateApplicationFundingAmountSuccess = (payload) => ({
  type: UPDATE_APPLICATION_FUNDING_AMOUNT_SUCCESS,
  payload,
});

export const updateApplicationFundingAmountError = (payload) => ({
  type: UPDATE_APPLICATION_FUNDING_AMOUNT_ERROR,
  payload,
});

export const bankApplicationFundingAmount = (payload) => ({
  type: BANK_APPLICATION_FUNDING_AMOUNT,
  payload,
});

export const bankApplicationFundingAmountSuccess = (payload) => ({
  type: BANK_APPLICATION_FUNDING_AMOUNT_SUCCESS,
  payload,
});

export const bankApplicationFundingAmountError = (payload) => ({
  type: BANK_APPLICATION_FUNDING_AMOUNT_ERROR,
  payload,
});

export const updateBankApplicationFundingAmount = (payload) => ({
  type: UPDATE_BANK_APPLICATION_FUNDING_AMOUNT,
  payload,
});

export const updateBankApplicationFundingAmountSuccess = (payload) => ({
  type: UPDATE_BANK_APPLICATION_FUNDING_AMOUNT_SUCCESS,
  payload,
});

export const updateBankApplicationFundingAmountError = (payload) => ({
  type: UPDATE_BANK_APPLICATION_FUNDING_AMOUNT_ERROR,
  payload,
});

export const metalStreamFunding = (payload) => ({
  type: METAL_STREAM_FUNDING,
  payload,
});

export const metalStreamFundingSuccess = (payload) => ({
  type: METAL_STREAM_FUNDING_SUCCESS,
  payload,
});

export const metalStreamFundingError = (payload) => ({
  type: METAL_STREAM_FUNDING_ERROR,
  payload,
});

export const updateMetalStreamFunding = (payload) => ({
  type: UPDATE_METAL_STREAM_FUNDING,
  payload,
});

export const updateMetalStreamFundingSuccess = (payload) => ({
  type: UPDATE_METAL_STREAM_FUNDING_SUCCESS,
  payload,
});

export const updateMetalStreamFundingError = (payload) => ({
  type: UPDATE_METAL_STREAM_FUNDING_ERROR,
  payload,
});
